<template>
  <v-card>
    <v-card-title class="toptitle">
      <span class="text-h3 capitalized">
        {{ type }} Charger Maintenance
      </span>
    </v-card-title>
    <v-form
      ref="form"
      lazy-validation
    >
      <v-card class="addNewCard">
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col
                v-if="authUser.isAdmin"
                cols="12"
                sm="6"
              >
                <v-autocomplete
                  v-model="booking.product"
                  :disabled="disabledField"
                  dense
                  :items="['oem', 'cso']"
                  :label="$t('select_product_*')"
                  :rules="[rules.required]"
                  @change="tenantList"
                />
              </v-col>
              <v-col
                v-if="authUser.isAdmin"
                cols=" 12"
                sm="6"
              >
                <v-autocomplete
                  v-model="booking.tenant_id"
                  :disabled="disabledField"
                  dense
                  :items="
                    booking.product
                      ? booking.product == 'oem'
                        ? tenantsOEM
                        : tenantsCSO
                      : []
                  "
                  :label="$t('select_tenant_*')"
                  item-text="name"
                  item-value="id"
                  :rules="[rules.required]"
                  @change="onTenantChange"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-autocomplete
                  v-model="booking.location"
                  :disabled="disabledField"
                  dense
                  clearable
                  :loading="isLocation"
                  :items="locationsList"
                  item-value="id"
                  item-text="name"
                  :label="$t('location') + ' *'"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-autocomplete
                  v-model="booking.charge_point_id"
                  :disabled="disabledField"
                  dense
                  clearable
                  :loading="booking.location ? isLocation : false"
                  :items="chargeStationList"
                  item-value="charge_point_id"
                  item-text="charge_point_id"
                  :label="$t('charge_point_id') + ' *'"
                  :rules="[rules.required]"
                />
              </v-col>

              <v-col
                cols="12"
                sm="6"
              >
                <DateTime
                  v-model="booking.date"
                  custom-class="form-field"
                  :label="$t('select_date_*')"
                  :range="true"
                  :min="getCurrentDate()"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col
                cols="12"
                sm="12"
              >
                <v-textarea
                  v-model="booking.description"
                  dense
                  rows="2"
                  :label="$t('maintenance_desc_*')"
                  :rules="[rules.required]"
                  clearable
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-form>
 
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="red darken-1"
        text
        @click="close()"
      >
        Close
      </v-btn>
      <v-btn
        color="primary"
        text
        :loading="isLoading"
        @click="submitMaintenance()"
      >
        {{ type }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { validationRules } from "@/mixins/validationRules";
import { mapGetters } from "vuex";
// import { debounce } from "lodash";

export default {
  components: {
    // dataTableScroll: () => import("@/components/base/dataTableScroll.vue"),
    // selectDate: () => import("@/components/base/SingleDatePicker.vue"),
    DateTime: () => import("@/components/base/DateTime.vue"),
  },
  mixins: [validationRules],
  props: {
    type: {
      type: String,
      default() {
        return "Create";
      },
    },
    itemData: {
      type: Object,
      default() {
        return {};
      },
    },
    options: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      booking:{
        date:"",
        start_datetime:"",
        end_datetime:""
      }
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "chargerMaintaince/getLoading",

      tenantLoading: "tenantsManagement/getIsLoading",
      tenantsList: "tenantsManagement/getTenantOptions",
      tenantsOEM: "tenantsManagement/getTenantsOEM",
      tenantsCSO: "tenantsManagement/getTenantsCSO",
// 
      isLocation: "csmsChargeStations/getLoading",
      locationsList: "csmsChargeStations/getLocation",
      chargeStationList: "csmsChargeStations/getList",
    }),

      disabledField() {
        return this.type == "Update";
      },
  },
  watch:{
    "booking.location":{
      handler: function(val){
        this.booking.charge_point_id = null
        this.$store.dispatch("csmsChargeStations/list", {
          tenant_id: this.booking.tenant_id,
          location: val,
        }); 
      }
    }
  },

  async mounted() {
    if (this.type == "Create") {
      if (!this.authUser.isAdmin) {
        this.booking.tenant_id = this.authUser.tenant_id;
        this.onTenantChange(this.options.tenant_id);
      }
    }

    if (this.type == "Update") {
      this.tableView = true;
      this.booking = { ...this.itemData };
      this.booking.tenant_id = parseInt(this.booking.tenant_id);
      this.booking.location_id = parseInt(this.booking.location_id);
      await this.$store.dispatch("csmsChargeStations/LocationsList", {
        tenant_id: this.booking.tenant_id,
      });
    }
  },
  methods: {
    tenantList() {
      if (this.product == "oem") {
        this.tenantOEM = this.tenantsList.filter((r) => r.product == "oem");
      } else {
        this.tenantOEM = this.tenantsList.filter((r) => r.product == "cso");
      }
    },
    async fetchData() {
      const params = { ...this.options, ...this.customFilters };
      await this.$store.dispatch("csmsChargingSession/list", params);
    },

    async onTenantChange(v) {
      delete this.booking.location;
      delete this.booking.charge_point_id;
      const params = { tenant_id: v };
      await this.$store.dispatch("csmsChargeStations/LocationsList", params);
    },

    async submitMaintenance() {

      if (this.$refs.form.validate()) {
        const params = { ...this.booking };
        params.charge_station = this.chargeStationList.find(
          (c) => c.charge_point_id === this.booking.charge_point_id
        )?.id;
        params.start_datetime = this.booking.date[0];
        params.end_datetime = this.booking.date[1];
        delete params.date;
        // 
        params.maintenance_type = "scheduled",

        this.$emit("onsubmit", params)
      }
    },
   

    close() {
      this.$emit("onclose");
    },
    getCurrentDate() {
      const dt = new Date();
      const y = dt.getFullYear();
      let m = dt.getMonth() + 1;
      m = m < 10 ? `0${m}` : m;

      let d = dt.getDate();
      d = d < 10 ? `0${d}` : d;

      return `${y}-${m}-${d}`;
    },
  },
};
</script>
<style lang="sass" scoped>
$poppinReg: 'Poppins Regular', sans-serif
$poppinMed: 'Poppins Medium', sans-serif
$poppinSemi: 'Poppins SemiBold', sans-serif
$poppinBold: 'Poppins Bold', sans-serif

.searchBoxwithBtn
  display: flex
  flex-wrap: wrap
  align-items: center
  :deep .v-input
    width: 70%
    margin-right: 1.75rem
  :deep button
    margin: 0 !important
.toptitle
  #backBtn
    padding: 0 !important
    position: absolute
    left: 27px
    background: #eee
    display: flex
    align-items: center
    justify-content: center
    align-items: center
    margin: 0 !important
    :deep .v-btn__content
      .v-icon
        position: relative
        top: unset
        left: unset
        right: unset
        opacity: 1
        font-size: 21px
        color: #333
        height: 29px !important
.v-application
    .bodTop
        margin-top: 1rem !important
        display: block
        padding-top: 1rem
    .addNewCard
        box-shadow: 0 0 0 !important
        border: 0 !important
        .container
            padding-top: 0
            padding-bottom: 0
            .custom-h3
                font-size: 1.25rem !important
                color: #333
                font-family: $poppinMed !important
                margin-bottom: 0.75rem !important
                display: inline-block

.userAssignWrap
  display: flex
  margin: 0
  padding: 12px
  flex-wrap: wrap
  .rowWrap
    margin: 0 !important
    width: 100% !important
  .noMargin
    margin: -12px !important

.nopadding
  padding-left: 0 !important
  padding-right: 0 !important


.connectorsRow

  display: flex
  gap:1rem
  .field
    min-width:150px !important
    max-width:165px !important


.deleteButton
  cursor: pointer
  .deleteIcon
    &:hover
      color: red
</style>
